import React from 'react'
import { Descriptions, Spin } from 'antd'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/user'
import { IndexProps } from './interface'

export default function BaseInfo(props: IndexProps) {
  /*个人帐号信息-企业档案 */
  const { data, loading } = useRequest(async () => {
    const { data } = await api.queryUserEnterpriseUsingPOST()
    return data
  })

  return (
    <Spin spinning={loading}>
      <Descriptions title="基础信息">
        <Descriptions.Item label="企业档案编码">
          {data?.enterpriseCode}
        </Descriptions.Item>
        <Descriptions.Item label="企业全称">
          {data?.enterpriseName}
        </Descriptions.Item>
        <Descriptions.Item label="企业简称">
          {data?.shortName}
        </Descriptions.Item>
        <Descriptions.Item label="统一社会信用代码">
          {data?.uniformSocialCreditCode}
        </Descriptions.Item>
      </Descriptions>

      <Descriptions title="业务经理信息">
        <Descriptions.Item label="业务经理姓名">
          {data?.businessManagerName}
        </Descriptions.Item>
        <Descriptions.Item label="业务经理电话">
          {data?.businessManagerMobile}
        </Descriptions.Item>
        <Descriptions.Item label="业务经理邮箱">
          {data?.businessManagerEmail}
        </Descriptions.Item>
      </Descriptions>
    </Spin>
  )
}
